import React, { useState, useEffect, useCallback } from "react";
import {
  Stack,
  ButtonBase,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
  Box,
} from "@mui/material";
import { Link } from "react-router-dom";
import { Spiral as Hamburger } from "hamburger-react";

const Navbar = () => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  useEffect(() => {
    const closeMenuOnScroll = () => {
      if (anchorEl) {
        handleMenuClose();
      }
    };

    window.addEventListener("scroll", closeMenuOnScroll);
    return () => {
      window.removeEventListener("scroll", closeMenuOnScroll);
    };
  }, [anchorEl, handleMenuClose]);

  return (
    <>
      {isMobile ? (
        <>
          {/* Background Overlay */}
          {anchorEl && (
            <Box
              sx={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0, 0, 0, 0.5)", // Dark tint overlay
                backdropFilter: "blur(1px)", // Blur effect
                zIndex: 10, // Ensures it stays above other elements
                transition: "all 0.3s ease-in-out",
              }}
              onClick={handleMenuClose} // Close when clicking outside menu
            />
          )}

          <IconButton
            edge="end"
            aria-label="menu"
            onClick={handleMenuOpen}
            disableRipple={true}
            sx={{ zIndex: 11 }} // Ensure button stays on top
          >
            <Hamburger
              size={25}
              toggled={Boolean(anchorEl)}
              toggle={setAnchorEl}
              color="#a1a1aa"
            />
          </IconButton>

          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            disableScrollLock={true}
            elevation={1}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            sx={{
              "& .MuiPaper-root": {
                backgroundColor: "#18181b", // Dark background
                color: "#a1a1aa",
                zIndex: 12, // Ensure menu is above overlay
              },
            }}
          >
            <MenuItem onClick={handleMenuClose}>
              <Link
                to="/"
                style={{
                  textDecoration: "none",
                  color: "#a1a1aa",
                  width: "12rem",
                }}
              >
                Home
              </Link>
            </MenuItem>
            <MenuItem onClick={handleMenuClose}>
              <Link
                to="/portfolio"
                style={{
                  textDecoration: "none",
                  color: "#a1a1aa",
                  width: "12rem",
                }}
              >
                Portfolio
              </Link>
            </MenuItem>
            <MenuItem onClick={handleMenuClose}>
              <Link
                to="/contact"
                style={{
                  textDecoration: "none",
                  color: "#a1a1aa",
                  width: "12rem",
                }}
              >
                Contact Us
              </Link>
            </MenuItem>
          </Menu>
        </>
      ) : (
        <Stack spacing={4} direction="row">
          <ButtonBase disableRipple disableTouchRipple>
            <Link to="/" style={{ textDecoration: "none" }}>
              <Typography color="#a1a1aa">Home</Typography>
            </Link>
          </ButtonBase>
          <ButtonBase disableRipple disableTouchRipple>
            <Link to="/portfolio" style={{ textDecoration: "none" }}>
              <Typography color="#a1a1aa">Portfolio</Typography>
            </Link>
          </ButtonBase>
          <ButtonBase disableRipple disableTouchRipple>
            <Link to="/contact" style={{ textDecoration: "none" }}>
              <Typography color="#a1a1aa">Contact Us</Typography>
            </Link>
          </ButtonBase>
        </Stack>
      )}
    </>
  );
};

export default Navbar;
